module.exports = __webpack_public_path__ + "media/video.324f6dc9.webm";